import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

/**
 * Live date·time readout for the kiosk top bar, matching the handoff TopBar
 * clock. Updates every 30 seconds and formats in the active UI language.
 *
 * @since 1.0.0
 * @example
 * ```tsx
 * <KioskClock />
 * ```
 */
export function KioskClock() {
  const { i18n } = useTranslation();
  const [now, setNow] = useState(() => new Date());

  useEffect(function tickKioskClock() {
    const id = setInterval(() => setNow(new Date()), 30_000);
    return function stopKioskClock() {
      clearInterval(id);
    };
  }, []);

  const locale = i18n.language || "de";
  const date = now.toLocaleDateString(locale, {
    weekday: "long",
    day: "2-digit",
    month: "long",
  });
  const time = now.toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <span
      data-testid="frontdesk-kiosk-clock"
      className="hidden min-w-[110px] text-right text-[13.5px] text-muted-foreground tabular-nums lg:block"
    >
      {date} · {time}
    </span>
  );
}
